module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('right-panel', {
    ref: "right-panel",
    attrs: {
      "datas": _vm.connects
    },
    on: {
      "onClose": _vm.onClose
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('translate', [_vm._v("Setting WorkGroup")])], 1), _vm._v(" "), _c('div', {
    staticClass: "wrapper-padding",
    slot: "content"
  }, [_c('el-form', {
    ref: "workgropForm",
    attrs: {
      "model": _vm.setting,
      "rules": _vm.rules,
      "label-width": "110px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.attrText.name,
      "prop": "name"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.setting.name),
      callback: function($$v) {
        _vm.setting.name = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "setting.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.desc,
      "prop": "desc"
    }
  }, [_c('el-input', {
    staticClass: "right-panel-textarea",
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.setting.desc),
      callback: function($$v) {
        _vm.setting.desc = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "setting.desc"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "detail-btn",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.setting.isCanSubmit
    },
    on: {
      "click": function($event) {
        _vm.onSubmitForm()
      }
    }
  }, [_c('translate', [_vm._v("Submit")])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.$refs['right-panel'].onClose()
      }
    }
  }, [_c('translate', [_vm._v("Cancel")])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fdb0b54e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/model/workgroup-setting.vue
// module id = 625
// module chunks = 4 5 6